import React, { createContext, useContext, useState, useEffect } from 'react';
import { appSettingsService } from '@root/shared/services/AppSettingsService';

interface AuthenticationConfig {
  authorityUrl: string;
  clientId: string;
}

interface ApplicationConfig {
  initialized: boolean;
  adminApiAddress: string;
  apiKey: string;
  authentication: AuthenticationConfig;
}

interface ApplicationContextType {
  config: ApplicationConfig;
}

const DEFAULT_CONFIG: ApplicationConfig = {
  initialized: false,
  adminApiAddress: '',
  apiKey: '',
  authentication: {
    authorityUrl: '',
    clientId: ''
  }
};

const ApplicationContext = createContext<ApplicationContextType>({
  config: DEFAULT_CONFIG
});

export const ApplicationContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<ApplicationConfig>(DEFAULT_CONFIG);

  useEffect(() => {
    appSettingsService.loadSettings().then((settings) => {
      setConfig({
        initialized: true,
        adminApiAddress: settings.Api.BaseUrl,
        apiKey: settings.Api.ApiKey,
        authentication: {
          authorityUrl: settings.Auth.IdentityServerUrl,
          clientId: settings.Auth.ClientId,
        },
      });
    });
  }, []);

  return (
    <ApplicationContext.Provider value={{ config }}>
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplicationContext = () => {
  return useContext(ApplicationContext);
};
